<template>
  <div class="logged-in">
    <BildirimlerMini />
    <v-divider vertical color="primary" :thickness="1" ></v-divider>
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn v-if="userInfo.photo" class="profile-btn" v-bind="props" :prepend-avatar="userInfo.photo" color="white" :loading="isLoading"
          variant="text" :text="!isLoading ? userInfo ? userInfo.firstName + ' ' + userInfo.lastName : '' : ''">
          <template v-slot:append>
            <svg-icon type="mdi" :path="pathMenu"></svg-icon>
          </template>
        </v-btn>
        <v-btn v-else v-bind="props" class="profile-btn" :prepend-icon="pathAccount" :color="isHomePage ? 'white' : 'darkPrimary'" variant="text"
          :text="!isLoading ? userInfo ? userInfo.firstName + ' ' + userInfo.lastName : '' : ''">
          <template v-slot:append>
            <svg-icon type="mdi" :path="pathMenu"></svg-icon>
          </template>
        </v-btn>
      </template>
      <v-list :lines="false" density="compact" nav>
        <v-list-item class="hover-color-primary" v-for="(item, i) in profileRoutes" :key="i" :value="item"
          color="primary" :to="item.route">
          <template v-slot:prepend>
            <svg-icon type="mdi" :path="item.icon" class="mr-8" color="gray"></svg-icon>
          </template>
          <v-list-item-title v-text="item.text"></v-list-item-title>
        </v-list-item>
        <v-list-item @click="logout" base-color="error">
          <template v-slot:prepend>
            <svg-icon type="mdi" :path="path" class="mr-8"></svg-icon>
          </template>
          <v-list-item-title>Çıkış Yap</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>


  </div>

</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "pinia";
import BildirimlerMini from "./bildirimlerMini.vue";
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiLogout } from "@mdi/js";
import { mdiMenuDown } from '@mdi/js';
import { mdiAccount } from '@mdi/js';
export default defineComponent({
  name: "loggedIn",
  components: {
    SvgIcon,
    BildirimlerMini,
  },
  data() {
    return {
      router: useRouter(),
      route: useRoute(),
      isLoading: true,
      path: mdiLogout,
      pathMenu: mdiMenuDown,
      pathAccount: mdiAccount,
    };
  },
  computed: {
    ...mapState(useMyUserStore, ["userInfo", "getUserFullName", "getProfileRoutes", "getMe"]),
    profileRoutes(): Array<{ id: number; route: string; text: string; icon: string }> {
      if (typeof window !== 'undefined') {
        return this.getProfileRoutes;
      }
      return [];
    },
    isHomePage() {
      return this.route.path === '/';
    },
  },
  mounted() {
  },
  beforeUnmount() {
  },
  methods: {
    logout() {
      const useStore = useMyUserStore();
      useStore.Logout();
    },
  },
  watch: {
    userInfo: {
      handler(newValue) {
        this.isLoading = !(newValue?.firstName && newValue?.lastName);
      },
      immediate: true,
      deep: true
    }
  },

});
</script>

<style scoped></style>
